import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../utils/api';

export default function WishlistWidget() {
  const [wishes, setWishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    API.get('/wishlist')
      .then(res => setWishes(res.data.wishes || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const deleteWish = async (id) => {
    try {
      await API.delete(`/wishlist/${id}`);
      setWishes(prev => prev.filter(w => w._id !== id));
    } catch {}
  };

  const generateFromWish = (wish) => {
    navigate(`/dashboard/generate?wish=${encodeURIComponent(wish.wish)}&childId=${wish.child}&wishId=${wish._id}`);
  };

  const activeWishes = wishes.filter(w => !w.isUsed);
  if (loading || activeWishes.length === 0) return null;

  return (
    <div className="card border-0 shadow-sm rounded-4 p-4 mb-4" style={{ background: 'var(--card-bg)' }}>
      <div className="d-flex align-items-center gap-2 mb-3">
        <span style={{ fontSize: '20px' }}>⭐</span>
        <h6 className="fw-bold mb-0" style={{ color: 'var(--text-main)', fontFamily: "'Fredoka One',cursive" }}>
          Story Wishes
        </h6>
        <span className="badge rounded-pill ms-1" style={{ background: 'var(--purple-section)', color: '#6f42c1', fontSize: '11px' }}>
          {activeWishes.length}
        </span>
      </div>
      <p className="text-muted small mb-3">Your child's story requests — tap to generate!</p>

      <div className="d-flex flex-column gap-2">
        {activeWishes.slice(0, 5).map(wish => (
          <div key={wish._id} className="d-flex align-items-center gap-2 p-3 rounded-3"
            style={{ background: 'var(--item-bg)', border: '1px solid var(--border-purple)' }}>
            <span style={{ fontSize: '18px', flexShrink: 0 }}>🌟</span>
            <span className="flex-grow-1 small" style={{ color: 'var(--text-body)' }}>{wish.wish}</span>
            <button className="btn btn-sm btn-dream rounded-pill px-3"
              style={{ fontSize: '12px', flexShrink: 0 }}
              onClick={() => generateFromWish(wish)}>
              Generate
            </button>
            <button className="btn btn-sm btn-outline-secondary rounded-circle"
              style={{ width: '28px', height: '28px', padding: 0, flexShrink: 0, fontSize: '11px' }}
              onClick={() => deleteWish(wish._id)}>
              <i className="bi bi-x"></i>
            </button>
          </div>
        ))}
      </div>

      {activeWishes.length > 5 && (
        <p className="text-muted text-center small mt-2 mb-0">+{activeWishes.length - 5} more wishes</p>
      )}
    </div>
  );
}
